import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ExchangeResponse, Tenant } from '../../../models/domain';
import { TenantService } from '../../http/tenant/tenant.service';
import { TenantSubDomainExtractorService } from '../../tenant-sub-domain-extractor/tenant-sub-domain-extractor.service';

@Injectable()
export class TenantFacadeService {
  private bySubdomainCache: { [subdomain: string]: Tenant } = {};

  constructor(
    private tenantService: TenantService,
    private tenantIdExtractorService: TenantSubDomainExtractorService
  ) { }

  getCurrentTenantAsync(): Promise<Tenant> {
    return firstValueFrom(this.getTenantBySubdomain(this.tenantIdExtractorService.getCurrentTenantSubDomain()));
  }

  getTenantBySubdomain(tenantSubDomain: string): Observable<Tenant> {
    if (tenantSubDomain in this.bySubdomainCache) {
      return of(this.bySubdomainCache[tenantSubDomain]);
    }

    return this.tenantService
      .getTenantBySubdomain(tenantSubDomain)
      .pipe(tap((tenant) => (this.bySubdomainCache[tenantSubDomain] = tenant)));
  }

  exchangeTokenAsync(secretId: string, secretCode: string): Promise<ExchangeResponse> {
    return firstValueFrom(this.tenantService.exchangeToken(secretId, secretCode));
  }
}
